
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cardiac-surgery",
      function () {
        return require("private-next-pages/cardiac-surgery.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cardiac-surgery"])
      });
    }
  